import { vars } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';

const loadingBarContainerStyles = css`
  height: 4px;
  overflow: hidden;
  position: relative;
  top: 0;
  width: 100%;

  &::after {
    animation: marquee 2s linear infinite;
    background: ${vars.colors.decoration.primary};
    content: '';
    height: 4px;
    position: absolute;
    width: 400px;
    z-index: 2;
  }

  @keyframes marquee {
    from {
      left: -300px;
    }
    to {
      left: 100%;
    }
  }

  @media ${mediaQueries.medium.up} {
    background: ${vars.colors.page.background.primary};
  }
`;

const LoadingBar = () => {
  return <div className={loadingBarContainerStyles} />;
};

export default LoadingBar;
